import env from 'libs/constants/env';
import ApiProvider from 'libs/providers/api/api.provider';
import { Observable } from 'rxjs';
import ChannelResponse from '../models/channelResponse';
import { AjaxResponse } from 'rxjs/ajax';

class ChannelProvider {
  constructor(private readonly provider: ApiProvider = new ApiProvider()) { }

  getChannelByUrl = (
    channel: string,
    authorization: string,
  ): Observable<AjaxResponse<ChannelResponse>> =>
    this.provider.get<ChannelResponse>(
      `${env.CONTEXT_PATH}/canales/${channel}/obtener-activo`,
      {
        Authorization: authorization,
        'Transaccion-Id': env.DEFAULT_REQUEST_ID,
      },
    );
}
export default ChannelProvider;
